"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryMapping = exports.countryNameMapping = exports.countryCode3Mapping = exports.countryCode2Mapping = exports.countryNameList = exports.countryCode3List = exports.countryCode2List = exports.countryMappings = void 0;
exports.countryMappings = require("../country-business-rules/v4/country-mapping/country-mapping-list.json");
exports.countryCode2List = require("../country-business-rules/v4/country-mapping/country-code-2-list.json");
exports.countryCode3List = require("../country-business-rules/v4/country-mapping/country-code-2-list.json");
exports.countryNameList = require("../country-business-rules/v4/country-mapping/country-name-list.json");
exports.countryCode2Mapping = require("../country-business-rules/v4/country-mapping/country-code-2-mapping.json");
exports.countryCode3Mapping = require("../country-business-rules/v4/country-mapping/country-code-3-mapping.json");
exports.countryNameMapping = require("../country-business-rules/v4/country-mapping/country-name-mapping.json");
function getCountryMapping(country) {
    const casedCountry = country.toUpperCase();
    let mapping = {};
    switch (casedCountry.length) {
        case 0:
        case 1:
            throw `Could not locate mapping for invalid country: ${casedCountry}`;
        case 2:
            mapping = exports.countryCode2Mapping;
            break;
        case 3:
            mapping = exports.countryCode3Mapping;
            break;
        default:
            mapping = exports.countryNameMapping;
    }
    if (!(casedCountry in mapping)) {
        throw `Could not locate mapping for country: ${casedCountry}`;
    }
    return mapping[casedCountry];
}
exports.getCountryMapping = getCountryMapping;
